<template>
  <div class="moow-master-container">
    <header-alt></header-alt>
    <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <div class="cover-photo-container" :class="{ aboveAll: isFullscreen }">
      <img
        v-if="!viewedByOwner"
        :src="currentListingAnalyticsPixel"
        class="pixel-holder"
      />
      <div
        class="cover-photo-loader"
        :style="{
          background:
            'url(' + loaderIconWhite + ') no-repeat center center /cover',
        }"
      ></div>
      <div class="cover-video-container" v-if="showVideo">
        <iframe
          v-if="getEmbedLink(coverUrl_video)"
          class="cover-video-holder"
          :src="getEmbedLink(coverUrl_video)"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <h2 v-else class="align-rel h-center v-center">
          Cannot Play This Video
        </h2>

        <!-- Duplicated here because the iFrame will cast over everything else not in this div -->
        <preview-media-controls
          @emitNext="fullscreenNext()"
          @emitPrevious="fullscreenPrevious()"
          @emitClose="fullScreenClose()"
          @emitOpen="fullScreenOpen()"
          @emitSelectPhotos="selectPhotos"
          @emitSelectVideos="selectVideos"
          :isFullscreen="isFullscreen"
          :selectedMediaType="selectedMediaType"
          :disableVideosBtn="!getEmbedLink(coverUrl_video)"
        />
      </div>

      <div
        class="holder-cover-photo align-rel-container"
        id="cover-photo"
        v-bind:class="{ fullscreen: isFullscreen }"
        :style="{
          background: 'url(' + coverUrl + ') no-repeat center center /cover',
        }"
      >
        <div
          class="toggleFullScreenBlanket"
          v-if="!isFullscreen"
          v-on:click="fullScreenOpen()"
        ></div>

        <preview-media-controls
          @emitNext="fullscreenNext()"
          @emitPrevious="fullscreenPrevious()"
          @emitClose="fullScreenClose()"
          @emitOpen="fullScreenOpen()"
          @emitSelectPhotos="selectPhotos"
          @emitSelectVideos="selectVideos"
          :isFullscreen="isFullscreen"
          :selectedMediaType="selectedMediaType"
          :disableVideosBtn="!getEmbedLink(coverUrl_video)"
        />

        <img-gallery-min
          v-if="isFullscreen && !showVideo"
          class="toggleable-gallery"
          :images="dt.marketingDet.images"
          :selectImageFunction="selectImage"
        ></img-gallery-min>
      </div>
    </div>
    <div v-if="viewedByOwner" style="background-color: #f76765; width: 100%">
      <div class="container">
        <b-row class="pt-2 pb-2 mt-0 mb-0">
          <b-col class="mt-2" cols="6" lg="6">
            <span style="color: white">{{
              i18n_local.owner_preview_info
            }}</span>
          </b-col>
          <b-col offset-lg="4">
            <b-button
              style="
                color: white;
                border: 1px solid white;
                background-color: transparent;
              "
              @click="editPage"
              >{{ i18n_local.edit }}</b-button
            >
          </b-col>
        </b-row>
      </div>
    </div>
    <div
      v-else-if="propertyIsUnavailable"
      style="background-color: #fc5226; width: 100%"
    >
      <b-container>
        <b-row class="pt-2 pb-2 mt-0 mb-0">
          <b-col class="mt-2" cols="6" lg="6">
            <span style="color: white">{{
              i18n_local.listing_unavailable_error
            }}</span>
          </b-col>
          <b-col offset-lg="4">
            <b-button
              style="
                color: white;
                border: 1px solid white;
                background-color: transparent;
              "
              @click="navigateTo({ name: 'marketplace' })"
              >{{ i18n_local.see_others }}</b-button
            >
          </b-col>
        </b-row>
      </b-container>
    </div>
    <!-- <b-container class="mt-5 mb-2 pl-4">
     
    </b-container> -->
    <div class="container mt-3 mb-3">
      <b-row class="mt-5 mb-2">
        <b-col style="margin-left: 16px">
          <p>
            {{ getPropertySubType(dt.genDet.propType.subType).toUpperCase() }}
          </p>
          <p class="main-title">{{ dt.marketingDet.shortDesc }}</p>
          <p class="sub-title">
            {{ dt.location.address.street }} {{ dt.location.address.number }},
            {{ dt.location.address.municipality }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <md-card
            md-with-hover
            style="padding: 2em"
            id="contact-rep-card"
            class="island-card"
          >
            <md-card-content>
              <b-row align-h="between">
                <b-col lg="7" class="hide-when-small">
                  <b-row style="text-align: center">
                    <b-col>
                      <moow-button
                        :type="['light', 'fab', 'small', 'flat']"
                        btnText="1"
                      />
                      <p class="moow-txt mt-3">Chati üürileandjaga</p>
                      <p class="moow-txt light">
                        Chati otse läbi Moowle platvormi üürileandjaga ning pane
                        paika tingimused. E-posti teavituste kaudu saad alati
                        vestluse juurde naasta.
                      </p>
                    </b-col>
                    <b-col>
                      <moow-button
                        :type="['light', 'fab', 'small', 'flat']"
                        btnText="2"
                      />
                      <p class="moow-txt mt-3">Broneeri korter</p>
                      <p class="moow-txt light">
                        Sisesta enda andmed ning broneeri chati kaudu endale
                        korter. Peale omaniku kinnitust on korter teie!
                      </p>
                    </b-col>
                    <b-col>
                      <moow-button
                        :type="['light', 'fab', 'small', 'flat']"
                        btnText="3"
                      />
                      <p class="moow-txt mt-3">Allkirjasta leping</p>
                      <p class="moow-txt light">
                        Peale broneeringu kinnitamist allkirjastage leping
                        siinsel platvormil ja jätkake kogu infovahetust ühest
                        kohast.
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col lg="4" cols="12">
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <div
                        class="md-title"
                        v-show="!showHighlightedReversePrice"
                        @mouseover="reverseHighlightedPrice"
                      >
                        <!--SHOW PRICE-->
                        <h3>
                          {{ highlightedPriceComputed
                          }}{{ getCurrencySign(dt.txnDet.currency) }}
                        </h3>
                        <!-- -->
                        <div class="md-subhead">
                          /{{ highlightedPriceTierComputed }}
                        </div>
                      </div>
                      <div
                        class="md-title compensate-first-child-styles"
                        v-show="showHighlightedReversePrice"
                        @mouseleave="reverseHighlightedPrice"
                      >
                        <h3>
                          {{ highlightedReversePriceComputed
                          }}{{ getCurrencySign(dt.txnDet.currency) }}
                        </h3>
                        <div class="md-subhead">
                          /{{ highlightedPriceReverseTierComputed }}
                        </div>
                      </div>
                    </div>
                    <div class="md-layout-item">
                      <moow-avatar
                        md-menu-trigger
                        :imgSource="repUrl"
                        :title="repName"
                        @mClick="routeToUser"
                        size="large"
                      ></moow-avatar>
                    </div>
                  </div>

                  <b-row class="people-section">
                    <md-field>
                      <label for="people">{{
                        i18n_local.guests | capitalize
                      }}</label>
                      <md-select
                        v-model="howManyPeople"
                        name="people"
                        id="people"
                      >
                        <md-option value="1"
                          >1 {{ i18n_local.person }}</md-option
                        >
                        <md-option value="2"
                          >2 {{ i18n_local.people }}</md-option
                        >
                        <md-option value="3"
                          >3 {{ i18n_local.people }}</md-option
                        >
                        <md-option value="4"
                          >4 {{ i18n_local.people }}</md-option
                        >
                        <md-option value="5+"
                          >5+ {{ i18n_local.people }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </b-row>
                  <b-row>
                    <b-col>
                      <moow-button
                        v-if="viewedByOwner"
                        :type="['dark', 'flat', 'outlined']"
                        :btnText="i18n_local.your_listing"
                        :disabled="true"
                      />
                      <moow-button
                        v-else-if="propertyIsUnavailable"
                        :type="['dark', 'flat', 'outlined']"
                        :btnText="i18n_local.unavailable"
                        :disabled="true"
                      />
                      <div v-else @click="showDatePeriodDialog = true">
                        <moow-button
                          :loading="creatingRequest || loadingRep"
                          :type="['light', 'flat']"
                          :btnText="getChatButtonText()"
                          :camel="true"
                        />
                        <img :src="chatBubble" alt="Chat" />
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </md-card-content>
            <!-- The following hidden div is required to make the computed property listen for variable changes  -->
            <div style="visibility: hidden">
              {{ currentPriceTierComputedSetter }}
            </div>
          </md-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="content-container">
          <b-row>
            <b-col cols="12" lg="6">
              <md-card class="island-card">
                <md-card-content>
                  <capacity-preview
                    :listing="dt"
                    v-if="!loading"
                  ></capacity-preview>
                </md-card-content>
              </md-card>
            </b-col>
            <b-col cols="12" lg="6">
              <md-card class="island-card">
                <md-card-content>
                  <b-row class="mt-4">
                    <b-col>
                      <span class="moow-txt large">{{
                        i18n_local.conditions | capitalize
                      }}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-row class="custom">
                        <b-col>
                          <span class="align-middle propertyKey">{{
                            i18n_local.price_starting_at
                          }}</span>
                        </b-col>
                        <b-col class="text-right">
                          <b-row>
                            <b-col>
                              <span
                                v-if="dt.txnDet.priceDaily"
                                class="align-middle"
                                >{{ defaultStartingFrom.dailyStartingFrom
                                }}{{ getCurrencySign(dt.txnDet.currency) }} /
                                {{ i18n_local.day }}</span
                              >
                              <span
                                class="align-middle"
                                v-if="dt.txnDet.priceMonthly"
                                >{{ defaultStartingFrom.monthlyStartingFrom
                                }}{{ getCurrencySign(dt.txnDet.currency) }} /
                                {{ i18n_local.month }}</span
                              >
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row class="custom" v-if="dt.txnDet.depositMonthly">
                        <b-col>
                          <span class="align-middle propertyKey">{{
                            i18n_local.deposit | capitalize
                          }}</span>
                        </b-col>
                        <b-col class="text-right">
                          <span class="align-middle"
                            >{{ dt.txnDet.depositMonthly
                            }}{{ getCurrencySign(dt.txnDet.currency) }}</span
                          >
                        </b-col>
                      </b-row>
                      <b-row class="custom" v-if="notEmpty(addFeesDisplayable)">
                        <b-col>
                          <span class="align-middle propertyKey">{{
                            i18n_local.additional_fees
                          }}</span>
                        </b-col>
                        <b-col class="text-right">
                          <span class="align-middle">{{
                            addFeesDisplayable
                          }}</span>
                        </b-col>
                        <div class="w-100"></div>
                        <b-col></b-col>
                        <b-col class="text-right propertyKey">{{
                          dt.txnDet.ADDFees.desc
                        }}</b-col>
                      </b-row>
                      <b-row
                        class="custom"
                        v-if="notEmpty(dt.txnDet.priceIncludes)"
                      >
                        <b-col>
                          <span class="align-middle propertyKey">{{
                            i18n_local.price_includes
                          }}</span>
                        </b-col>
                        <b-col class="text-right">
                          <span class="align-middle">{{
                            dt.txnDet.priceIncludes | capitalize
                          }}</span>
                        </b-col>
                      </b-row>
                      <b-row class="mt-4" v-if="notEmpty(dt.techDet.suitable)">
                        <b-col>
                          <span
                            style="
                              font-size: 15px;
                              text-align: left;
                              font-weight: bold;
                            "
                            >{{ i18n_local.house_rules | allCaps }}</span
                          >
                        </b-col>
                      </b-row>

                      <property-rules :listing="dt"></property-rules>
                    </b-col>
                  </b-row>
                </md-card-content>
              </md-card>
            </b-col>
          </b-row>

          <md-card class="island-card">
            <md-card-content>
              <b-row class="mt-4">
                <b-col>
                  <span class="moow-txt large">{{
                    i18n_local.description | capitalize
                  }}</span>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col
                  class="align-self-middle"
                  v-if="notEmpty(dt.techDet.sanOptions)"
                >
                  <span
                    class="align-middle"
                    style="font-size: 16px; text-align: left; font-weight: bold"
                    >{{ i18n_local.sanitary | allCaps }}</span
                  >
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-row class="custom" v-if="notEmpty(dt.techDet.sanOptions)">
                    <b-col>
                      <span class="align-middle propertyKey">{{
                        i18n_local.options | allCaps
                      }}</span>
                    </b-col>
                    <b-col class="text-right">
                      <span class="align-middle">{{
                        dt.techDet.sanOptions | capitalize
                      }}</span>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col>
                  <div
                    class="desc-container text-note"
                    v-bind:class="{ expanded: descExpanded }"
                  >
                    <pre>{{ formattedDescription }}</pre>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-2" v-if="showDescriptionRow">
                <b-col>
                  <div
                    class="desc-show-more"
                    v-bind:class="{ up: descExpanded }"
                    v-on:click="toggleDescContainerExpand()"
                  >
                    {{ descExpandToggleText }}
                    <i class="desc-show-more-icon"></i>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-4" v-if="showDescriptionRow">
                <b-col cols="12" sm="4" md="4" lg="8" xl="8"></b-col>
                <b-col
                  v-if="showEstDescSelector"
                  v-bind:class="{ selected: selectedDescLang == 'est' }"
                  class="desc-lang-selector align-right"
                  cols="2"
                  sm="2"
                  md="2"
                  lg="1"
                  xl="1"
                  v-on:click="selectDifferentLangDesc('est')"
                  >EST</b-col
                >
                <b-col
                  v-if="showEngDescSelector"
                  v-bind:class="{ selected: selectedDescLang == 'eng' }"
                  class="desc-lang-selector align-right"
                  cols="2"
                  sm="2"
                  md="2"
                  lg="1"
                  xl="1"
                  v-on:click="selectDifferentLangDesc('eng')"
                  >ENG</b-col
                >
                <b-col
                  v-if="showRusDescSelector"
                  v-bind:class="{ selected: selectedDescLang == 'rus' }"
                  class="desc-lang-selector align-right"
                  cols="2"
                  sm="2"
                  md="2"
                  lg="1"
                  xl="1"
                  v-on:click="selectDifferentLangDesc('rus')"
                  >RUS</b-col
                >
              </b-row>
              <b-row class="mt-4" v-if="notEmpty(dt.techDet.amenities)">
                <b-col>
                  <span
                    style="font-size: 15px; text-align: left; font-weight: bold"
                    >{{ i18n_local.amenities | allCaps }}</span
                  >
                </b-col>
              </b-row>
              <b-row class="custom" v-if="notEmpty(dt.techDet.amenities)">
                <b-col
                  lg="6"
                  class="text-left"
                  v-for="(amenity, id) in dt.techDet.amenities"
                  :key="id"
                >
                  <span class="align-middle">{{
                    getAmenityTextFrom(amenity)
                  }}</span>
                </b-col>
              </b-row>
            </md-card-content>
          </md-card>

          <md-card class="island-card">
            <md-card-content>
              <b-row class="mt-4">
                <b-col>
                  <span class="moow-txt large">{{
                    i18n_local.property | capitalize
                  }}</span>
                </b-col>
              </b-row>

              <property-tech-details :listing="dt"></property-tech-details>
            </md-card-content>
          </md-card>

          <md-card class="island-card">
            <md-card-content>
              <b-row class="mt-4">
                <b-col>
                  <span class="moow-txt large">{{
                    i18n_local.location | capitalize
                  }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="map-container">
                    <gmap-map
                      v-if="mapLoadedSuccess"
                      ref="mymap"
                      :center="mapStartLocation"
                      :zoom="17"
                      style="width: 100%; min-height: 618px"
                    >
                      <gmap-marker :position="mapStartLocation" />
                    </gmap-map>
                    <div v-else>Map not available</div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="custom">
                <b-col lg="12">{{ dt.location.address.formattedAD }}</b-col>
                <b-col lg="12"
                  >{{ dt.location.address.street }}
                  {{ dt.location.address.number }},
                  {{ dt.location.address.municipality }}</b-col
                >
                <b-col lg="12">{{ dt.location.address.county }}</b-col>
                <b-col lg="12">{{ dt.location.address.country }}</b-col>
              </b-row>
            </md-card-content>
          </md-card>
          <div v-if="tagwords.length != 0">
            <md-card class="island-card">
              <md-card-content>
                <b-row class="mt-4">
                  <b-col>
                    <span
                      style="
                        font-size: 15px;
                        text-align: left;
                        font-weight: bold;
                      "
                      >{{ i18n_local.tags | allCaps }}</span
                    >
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col>
                    <md-chips
                      v-model="tagwords"
                      md-static
                      class="mo-chips"
                    ></md-chips>
                  </b-col>
                </b-row>
              </md-card-content>
            </md-card>
          </div>
        </b-col>
      </b-row>
    </div>

    <md-dialog
      width="400"
      :md-close-on-esc="true"
      :md-click-outside-to-close="true"
      :md-active.sync="showDatePeriodDialog"
      class="scrolly-dialog"
      md-fullscreen
    >
      <md-dialog-title class="moow-header-2">{{
        i18n_local.choose_stay_period
      }}</md-dialog-title>
      <md-content style="padding: 1em">
        <date-picker
          :disabledDates="isDateBlocked"
          @emitDatesSelected="datesSelected"
          actionButtonTitle="Skip"
          @emitActionButton="skipDatePicker"
          :minDateRangeInDays="minStayPeriodInDays"
          :minRangeMessage="getMinRangeMessage(minStayPeriodInDays)"
        />
      </md-content>
    </md-dialog>

    <md-dialog
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
      :md-active.sync="showDialogLoginRegister"
      class="scrolly-dialog"
      md-fullscreen
    >
      <dialog-login-register
        style="margin: 0 auto"
        userRole="tenant"
        @emitProcessFinished="loginOrSignupProcessDone"
        @emitClose="closeLoginDialog"
      ></dialog-login-register>
    </md-dialog>
  </div>
</template>
<script>
import PreviewMediaControls from "@/components/listingComponents/previewMediaControls.vue";
import RollingPeriodDatepicker from "@/components/utils/rollingPeriodDatePicker.vue";
import {
  calculateDiffOfDays,
  formatTimeToDDMMYYFromString,
} from "@/timeFunctions.js";
import { getUserPublicByUId } from "@/functions.js";
import { prevListingModel } from "@/model/previewListingModel.js";
import { listingModel } from "@/dataModel.js";
const lists = require("@/lists.js");
import dayjs from "dayjs";

import { getTextValueFromObjectUsingValue } from "@/searchFunctions.js";
import { upsertRequest } from "@/requestRepository.js";
import { composeChatRedirectParams } from "@/chatRepository.js";
import { getServerApi } from "@/config/deployment";
import { getListingPublic } from "@/listings/repository/listingRepository";
import PropCapacityPreview from "@/components/listingComponents/propertyCapacityPreview.vue";
import PropertyRules from "@/components/listingComponents/propertyRules.vue";
import PropertyTechDetails from "@/components/listingComponents/propertyTechnicalDetails.vue";
import ImageGallery from "@/components/listingComponents/imgQuickGallery.vue";
import { getPricingRules } from "@/pricing/repository/pricingRepository.js";
import {
  getStartingFromDisplayPrice,
  calcRentPricingDetails,
  calcPricingTier,
  getDefaultStartingFromPrices,
} from "@/pricing/pricingCalculator.js";
import { addVisit } from "@/platform/analytics/services/analyticsService.js";
import DialogLoginRegister from "@/components/auth/DialogLoginRegister.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import { convertUrlToEmbedLink } from "@/third-party/youtube/utils/ytHelper.js";
import { AVAILABLE_EVENTS } from "@/third-party/firebase/services/firebaseService";
import { captureException, captureEvent } from "@/utils/reporting/reportingService.js";
import ChatAutoMessenger, {
  getPropertyInquryMessage,
} from "@/platform/chat/services/ChatAutoMessenger";

export default {
  name: "preview",
  components: {
    "capacity-preview": PropCapacityPreview,
    "img-gallery-min": ImageGallery,
    "property-rules": PropertyRules,
    "property-tech-details": PropertyTechDetails,
    "dialog-login-register": DialogLoginRegister,
    "preview-media-controls": PreviewMediaControls,
    "rolling-period-dp": RollingPeriodDatepicker,
  },
  props: {
    listingId: {
      required: true,
    },
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    ...mapState("propertyCalendarModule", ["entries"]),
    minStayPeriodInDays() {
      if (this.dt.txnDet.priceDaily) return undefined;
      else return 31; // no daily pricing, min stay is 31 days
    },
    chatBubble() {
      return require("../../assets/icons/chatimull.svg");
    },
    bottomPriceTxt() {
      return (
        this.highlightedPriceComputed +
        this.getCurrencySign(this.dt.txnDet.currency) +
        " / " +
        this.highlightedPriceTierComputed
      );
    },
    listingOwnerUid() {
      if (this.dt && this.dt.creationDet) return this.dt.creationDet.createdBy;
      else return false;
    },
    propertyOwnerAccountId() {
      if (this.dt && this.dt.owner) return this.dt.owner.accountId;
      else return "";
    },
    currentUserUid() {
      if (this.$store.getters.user) return this.$store.getters.user.uid;
      else return false;
    },
    currentUserFirstName() {
      if (this.$store.getters.user) return this.$store.getters.user.firstName;
      else return false;
    },
    showDescriptionRow() {
      return (
        this.showEstDescSelector ||
        this.showEngDescSelector ||
        this.showRusDescSelector
      );
    },
    placeholder() {
      return require("../../assets/listing-hero-placeholder.png");
    },
    loadingBackground() {
      return require("../../assets/loading-background-static.svg");
    },
    priceIncludesIsSet() {
      return this.dt.txnDet.priceIncludes.length > 0;
    },
    avatarPlaceholder() {
      return require("../../assets/prof-pic-placeholder@2x.png");
    },
    loaderIcon() {
      return require("../../assets/loader-rolling.svg");
    },
    loaderIconWhite() {
      return require("../../assets/loader-rolling-white.svg");
    },
    highlightedPriceComputed() {
      if (!this.loading) {
        var moveIn, moveOut;
        if (this.selectedMoveInDate && this.selectedMoveOutDate) {
          var priceDetails = calcRentPricingDetails(
            this.baseRents,
            this.selectedMoveInDate,
            this.selectedMoveOutDate,
            this.discounts,
            this.$store.getters.pricingRules
          );
          if (priceDetails.priceTier == "month")
            return priceDetails.rentMonthly;
          else return priceDetails.rentDaily;
        } else {
          if (
            this.defaultStartingFrom.monthlyStartingFrom &&
            this.defaultStartingFrom.dailyStartingFrom
          ) {
            this.disableHighlightedPriceReverse = false;
            return this.defaultStartingFrom.monthlyStartingFrom;
          } else if (this.defaultStartingFrom.monthlyStartingFrom) {
            this.disableHighlightedPriceReverse = true;
            return this.defaultStartingFrom.monthlyStartingFrom;
          } else if (this.defaultStartingFrom.dailyStartingFrom) {
            this.disableHighlightedPriceReverse = true;
            return this.defaultStartingFrom.dailyStartingFrom;
          }
        }
      }
    },
    highlightedReversePriceComputed() {
      if (!this.loading) {
        var moveIn, moveOut;
        if (this.selectedMoveInDate && this.selectedMoveOutDate) {
          var priceDetails = calcRentPricingDetails(
            this.baseRents,
            this.selectedMoveInDate,
            this.selectedMoveOutDate,
            this.discounts,
            this.$store.getters.pricingRules
          );
          if (priceDetails.priceTier == "month") {
            this.disableHighlightedPriceReverse = false;
            if (priceDetails.rentForPreDays < priceDetails.rentForPostDays)
              return priceDetails.rentForPreDays.daily;
            else return priceDetails.rentForPostDays.daily;
          } else this.disableHighlightedPriceReverse = true;
        } else if (this.defaultStartingFrom.monthlyStartingFrom)
          return this.defaultStartingFrom.dailyStartingFrom;
        else if (this.defaultStartingFrom.dailyStartingFrom)
          return this.defaultStartingFrom.monthlyStartingFrom;
      }
    },
    highlightedPriceTierComputed() {
      if (this.displayPriceTier == "monthly") return "month";
      else return "day";
    },
    highlightedPriceReverseTierComputed() {
      if (this.displayPriceTier == "monthly") return "day";
      //reversed!
      else return "month";
    },
    currentPriceTierComputedSetter() {
      if (this.selectedMoveInDate && this.selectedMoveOutDate) {
        this.displayPriceTier = this.getPriceTier(
          this.selectedMoveInDate,
          this.selectedMoveOutDate
        );
        return this.displayPriceTier;
      }
    },
    formattedDescription() {
      return this.selectedDescription.replace(/\n-/g, "\n\u2022");
    },
    viewedByOwner() {
      if (!this.currentUserUid || !this.$store.getters.selectedAccount)
        return false;
      if (
        this.currentUserUid == this.listingOwnerUid ||
        this.$store.getters.selectedAccount == this.propertyOwnerAccountId
      )
        return true;
      return false;
    },
  },
  mounted() {},
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
  },
  created() {
    window.addEventListener("resize", this.handleWindowResize);
    this.handleWindowResize();
    this.serverApi = getServerApi();
    let token = "";
    this.loading = true;
    let listingPromise = getListingPublic(this.listingId);
    let pricingRulesPromise = getPricingRules();
    Promise.all([listingPromise, pricingRulesPromise])
      .then((results) => {
        if (this.narrowWidth) this.$emit("emitToggleSupportChat", false);
        if (results[0]) {
          this.loadingRep = true;
          getUserPublicByUId(results[0].owner.uid)
            .then((user) => {
              if (user) {
                if (user.pictureUrl && user.pictureUrl != "null")
                  this.repUrl = user.pictureUrl;
                if (user.firstName && user.firstName != "null")
                  this.repName = user.firstName;
                this.repMID = user.maaklerID;
              }
              this.loadingRep = false;
            })
            .catch((err) => {});
          this.mapListingResponseToUI(results[0]);
          this.addListingVisit(this.listingId);
          this.getEntries({
            propertyId: this.dt._id,
          });
        } else {
          this.$router.push("/");
          this.$notify({
            title: "Not Found",
            message: "Listing not found",
          });
        }
      })
      .catch((error) => {});
  },
  methods: {
    ...mapActions("propertyCalendarModule", [
      "checkAvailability",
      "getEntries",
    ]),
    getMinRangeMessage(minStayPeriodInDays) {
      // Minimum stay period is X days
      if (!minStayPeriodInDays) return "";
      return (
        this.i18n_local.min_stay_period_is +
        " " +
        minStayPeriodInDays +
        " " +
        this.i18n_local.days
      );
    },
    skipDatePicker() {
      this.showDatePeriodDialog = false;
      this.attempToTalkToLandlord();
    },
    datesSelected({ startDate, endDate }) {
      this.selectedMoveInDate = startDate;
      this.selectedMoveOutDate = endDate;
      this.showDatePeriodDialog = false;
      this.attempToTalkToLandlord();
    },
    getChatButtonText() {
      return (
        this.i18n_local.talk_to_owner +
        " " +
        this.repName +
        this.i18n_local.lng_with_who_case
      );
    },
    handleWindowResize() {
      this.narrowWidth = window.innerWidth <= 990;
    },
    loginOrSignupProcessDone(success) {
      if (success) {
        this.showDialogLoginRegister = false;
        this.creatingRequest = true;
        var v = this;
        // wait for the currentUserUid to be defined
        setTimeout(function () {
          if (v.currentUserUid) v.talkToLandlord();
        }, 300);
      }
    },
    closeLoginDialog() {
      this.showDialogLoginRegister = false;
    },
    getEmbedLink(videoUrl) {
      try {
        return convertUrlToEmbedLink(videoUrl);
      } catch (ex) {
        return false;
      }
    },
    addListingVisit(listingId) {
      addVisit(listingId);
    },
    getAmenityTextFrom(value) {
      var i;
      for (i = 0; i < this.amenities.length; i++) {
        if (this.amenities[i].value.localeCompare(value) == 0) {
          return this.amenities[i].text;
        }
      }
    },
    toggleMiniDatePicker() {
      this.showMiniDatePicker = !this.showMiniDatePicker;
    },
    mapListingResponseToUI(listing) {
      this.dt = listing;

      if (this.dt.techDet.storage.length > 0) {
        this.storageState = false;
        this.storageNr = this.dt.techDet.storage.length;
      }
      if (this.dt.techDet.nrOfBalconies > 0) {
        this.balconyTypeState = true;
        this.chk = true;
      }

      if (this.dt.txnDet.txnType == "rent") {
        this.txnTypeDisplayable = "Rent (monthly)";
      } else if (this.dt.txnDet.txnType == "rentShortTerm") {
        this.txnTypeDisplayable = "Rent (daily)";
      } else {
        this.txnTypeDisplayable = "Sale";
      }
      this.baseRents = this.getBaseRents(this.dt.txnDet);
      this.discounts = this.getDiscounts(this.dt.txnDet);
      this.defaultStartingFrom = getDefaultStartingFromPrices(
        this.baseRents,
        this.discounts
      );

      if (
        this.dt.txnDet.ADDFees.fee != null &&
        this.dt.txnDet.ADDFees.fee != ""
      ) {
        this.addFeesDisplayable =
          this.dt.txnDet.ADDFees.fee +
          this.getCurrencySign(this.dt.txnDet.currency);
      } else {
        this.addFeesDisplayable = "";
      }

      if (this.sale == "true") {
        this.saleView = true;
        this.rentView = false;
      }
      if (this.rent == "true") {
        this.rentView = true;
        this.saleView = false;
      }
      if (this.dt.genDet.propType == "land") {
        this.disabled = true;
      }

      // Set cover photo and first selected image index
      if (this.dt.marketingDet.images) {
        let idx = this.dt.marketingDet.images.findIndex((file) => {
          return file.cover == true;
        });
        if (idx > -1) {
          this.coverPhotoIdx = idx;
          this.coverUrl = this.dt.marketingDet.images[idx].url;
        } else this.coverUrl = this.placeholder;
      } else {
        this.coverUrl = this.placeholder;
      }

      // Set cover video and first selected video index
      if (this.dt.marketingDet.videos) {
        this.coverUrl_video = this.dt.marketingDet.videos[0];
      }

      if (this.dt.techDet.storage.length > 0) {
        this.storage = true;
      }
      if (this.dt.techDet.balcony.length > 0) {
        this.balconies = true;
        this.areaM2 = this.dt.techDet.balcony[0].areaM2;
      }

      this.nrOfKitchensTotalCalculated =
        this.dt.techDet.nrOfOpenKit + this.dt.techDet.nrOfKit;
      if (this.dt.techDet.nrOfOpenKit > 0) {
        this.openKitchenIfExists = "Open Kitchen";
      }
      if (this.dt.techDet.nrOfKit) {
        this.kitchenIfExists = "Kitchen";
      }

      this.nrOfBalconiesTotalCalculated = this.dt.techDet.nrOfBalconies;
      this.balconyIfExists = "";
      for (var i = 0; i < this.dt.techDet.balcony.length; i++) {
        this.balconyIfExists =
          this.balconyIfExists +
          getTextValueFromObjectUsingValue(
            this.balcony,
            this.dt.techDet.balcony[i].category
          );
      }

      this.nrOfStoragesTotalCalculated = this.dt.techDet.storage.length;
      this.allStoragesIfExists = "";
      for (var i = 0; i < this.dt.techDet.storage.length; i++) {
        if (i == 0)
          this.allStoragesIfExists = getTextValueFromObjectUsingValue(
            this.storageList,
            this.dt.techDet.storage[i]
          );
        else
          this.allStoragesIfExists =
            this.allStoragesIfExists +
            ", " +
            getTextValueFromObjectUsingValue(
              this.storageList,
              this.dt.techDet.storage[i]
            );
      }

      if (this.dt.marketingDet.tagwords) {
        let tags = this.dt.marketingDet.tagwords + "";
        this.tagwords = tags.split(",");
      }
      // User based information
      this.listingOwner = this.dt.owner.uid;

      if (!this.viewedByOwner)
        this.currentListingAnalyticsPixel =
          this.serverApi +
          "/api/analytics/listing/pixel/moowle?listingId=" +
          this.listingId;
      // Location related
      try {
        this.mapStartLocation.lat = Number(this.dt.location.geoCoords[0].lat);
        this.mapStartLocation.lng = Number(this.dt.location.geoCoords[0].lng);
        this.mapLoadedSuccess = true;
      } catch (err) {
        this.mapLoadedSuccess = false;
      }

      // DESCRIPTION
      if (this.dt.genDet.info.est) {
        this.showEstDescSelector = true;
      }
      if (this.dt.genDet.info.eng) {
        this.showEngDescSelector = true;
      }
      if (this.dt.genDet.info.rus) {
        this.showRusDescSelector = true;
      }

      let missingEngDesc,
        missingEstDesc,
        missingRusDesc = false;
      if (!this.dt.genDet.info.est) missingEstDesc = true;
      if (!this.dt.genDet.info.eng) missingEngDesc = true;
      if (!this.dt.genDet.info.rus) missingRusDesc = true;

      if (this.i18n_local.selectedLocale === "et-NL") {
        if (!missingEstDesc) {
          this.selectedDescription = this.dt.genDet.info.est;
          this.selectedDescLang = "est";
        } else {
          this.selectedDescription = this.dt.genDet.info.eng;
          this.selectedDescLang = "eng";
        }
      }
      if (this.i18n_local.selectedLocale === "en-NL") {
        if (!missingEngDesc) {
          this.selectedDescription = this.dt.genDet.info.eng;
          this.selectedDescLang = "eng";
        } else {
          this.selectedDescription = this.dt.genDet.info.est;
          this.selectedDescLang = "est";
        }
      }
      if (this.i18n_local.selectedLocale === "ru-NL") {
        if (!missingRusDesc) {
          this.selectedDescription = this.dt.genDet.info.rus;
          this.selectedDescLang = "rus";
        } else {
          this.selectedDescription = this.dt.genDet.info.eng;
          this.selectedDescLang = "eng";
        }
      }

      // PRICING
      if (this.dt.txnDet.priceMonthly) this.displayPriceTier = "monthly";
      else this.displayPriceTier = "daily";

      if (this.dt && this.dt.availDet)
        this.propertyIsUnavailable = this.dt.availDet.status != "active";
      else this.propertyIsUnavailable = false;

      this.loading = false;
    },
    // TODO: move to mix-in
    isDateBlocked(dateInQuestion) {
      const today = new Date();
      if (dateInQuestion < today) return true;

      if (!Array.isArray(this.entries) || !this.entries.length) {
        return false;
      }

      for (const entry of this.entries) {
        const startDate = dayjs(new Date(entry.startDate));
        const endDate = dayjs(new Date(entry.endDate));
        if (
          (dateInQuestion.isSame(startDate) ||
            dateInQuestion.isAfter(startDate)) &&
          (dateInQuestion.isSame(endDate) ||
            dateInQuestion.isBefore(endDate) ||
            entry.termless)
        ) {
          return true;
        }
      }

      return false;
    },
    reverseHighlightedPrice() {
      if (!this.disableHighlightedPriceReverse)
        this.showHighlightedReversePrice = !this.showHighlightedReversePrice;
    },
    getPriceTier(periodStart, periodEnd) {
      if (periodStart && periodEnd) {
        var daysDiff = calculateDiffOfDays(
          new Date(periodStart),
          new Date(periodEnd)
        );
        if (daysDiff < 30) return "daily";
      }
      return "monthly";
    },
    convertToSentenceCase(camelCased) {
      return camelCased
        .replace(/([A-Z]+)/g, " $1")
        .replace(/([A-Z][a-z])/g, " $1");
    },
    getNrOfPeopleValue(nrOfGuests) {
      if (nrOfGuests == 1) "1 Person";
      else return nrOfGuests + " People";
    },
    toggleDescContainerExpand() {
      if (this.descExpanded) {
        this.descExpandToggleText = "Read More";
        this.descExpanded = false;
      } else {
        this.descExpandToggleText = "Read Less";
        this.descExpanded = true;
      }
    },
    selectDifferentLangDesc(lang) {
      switch (lang) {
        case "est":
          if (this.dt.genDet.info.est)
            this.selectedDescription = this.dt.genDet.info.est;
          this.selectedDescLang = "est";
          break;
        case "eng":
          if (this.dt.genDet.info.eng)
            this.selectedDescription = this.dt.genDet.info.eng;
          this.selectedDescLang = "eng";
          break;
        case "rus":
          if (this.dt.genDet.info.rus)
            this.selectedDescription = this.dt.genDet.info.rus;
          this.selectedDescLang = "rus";
          break;
        default:
          this.selectedDescription = "";
      }
    },
    notEmpty(content) {
      if (Array.isArray(content)) return content.length > 0;
      else if (content) return true;
      else return false;
    },
    getConditionsType(txnType) {
      if (txnType == "sale") return "SALE";
      else return "RENTAL";
    },
    getPropertySubType(value) {
      var r;
      for (let item of lists.subPropertyTypeList) {
        if (item.value == value) {
          r = this.i18n_local[item.value];
          !r ? (r = item.text) : void 0;
        }
      }
      return r;
    },
    getCurrencySign(currency) {
      if (currency == "eur") return "€";
      else if (currency == "usd") return "$";
      else return "";
    },
    getTxnDisplayType(txnType) {
      if (txnType == "sale") return "sale";
      else return "rent";
    },
    getTxnPeriodType(txnType) {
      if (txnType == "rent") return " per month";
      else if (txnType == "rentShortTerm") return " per night";
    },
    redirectToLogin() {
      var payload =
        this.dt.location.address.street +
        " " +
        this.dt.location.address.number +
        ", " +
        this.dt.location.address.municipality;
      this.$router.push({
        name: "login",
        query: { redirect: "listing/" + this.dt.maaklerID },
      });
    },
    attempToTalkToLandlord() {
      captureEvent({
        event: AVAILABLE_EVENTS.select_content,
        params: {
          content_type: "Button press",
          item_id: "Talk to landlord",
        },
      });
      if (this.currentUserUid) this.talkToLandlord();
      else this.showDialogLoginRegister = true;
    },
    // TODO: instead, create a mix-in and plug it in
    async checkPropertyAvailability(request) {
      return await this.checkAvailability({
        propertyId: this.dt._id,
        startDate: request.periodStart,
        endDate: request.periodEnd,
        // startDate: new Date(request.periodStart).toISOString(),
        // endDate: new Date(request.periodEnd).toISOString(),
        termless: false,
      });
    },
    async talkToLandlord() {
      try {
        this.creatingRequest = true;
        var request = this.createNewListingRequest();
        if (request.periodStart && request.periodEnd) {
          if (!(await this.checkPropertyAvailability(request))) {
            this.notifyError("Selected dates are not available.");
            this.creatingRequest = false;
            return;
          }
        }

        var payload =
          this.dt.location.address.street +
          " " +
          this.dt.location.address.number +
          ", " +
          this.dt.location.address.municipality;
        var chatMessage = getPropertyInquryMessage({
          prospectName: this.currentUserFirstName,
          property: this.dt,
          periodStart: this.selectedMoveInDate,
          periodEnd: this.selectedMoveOutDate,
          nrOfGuests: this.howManyPeople,
        });
        var parameters = composeChatRedirectParams(
          this.listingOwner,
          chatMessage,
          payload
        );

        upsertRequest(request)
          .then((resp) => {
            this.redirectToChat(parameters);
            this.creatingRequest = false;
          })
          .catch((err) => {
            this.handleTalkToLandlordError(err);
          });
      } catch (ex) {
        this.handleTalkToLandlordError(ex);
      }
    },
    handleTalkToLandlordError(error) {
      console.log("error:", error);

      captureException(error);
      this.notifyError(
        "Something is not right",
        "Notified, we're solving the issue."
      );
      this.creatingRequest = false;
    },
    redirectToChat(parameters) {
      this.$router.push({
        name: "chat",
        params: parameters,
      });
    },
    createNewListingRequest() {
      try {
        let request = {
          propertyId: this.dt._id,
          listingMaaklerId: Number(this.listingId),
          prospectUid: this.currentUserUid,
          ownerUid: this.listingOwner,
          nrOfGuests: this.howManyPeople,
          txnDet: this.dt.txnDet,
          currency: this.dt.txnDet.currency,
          customOffer: undefined,
        };
        if (this.selectedMoveOutDate) {
          request.periodEnd = new Date(
            Date.UTC(
              this.selectedMoveOutDate.getFullYear(),
              this.selectedMoveOutDate.getMonth(),
              this.selectedMoveOutDate.getDate()
            )
          ).toISOString();
        }
        if (this.selectedMoveInDate) {
          request.periodStart = new Date(
            Date.UTC(
              this.selectedMoveInDate.getFullYear(),
              this.selectedMoveInDate.getMonth(),
              this.selectedMoveInDate.getDate()
            )
          ).toISOString();
        }

        return request;
      } catch (err) {
        return false;
      }
    },
    selectPhotos() {
      this.selectedMediaType = "photos";
      this.selectedMediaIdx = this.coverPhotoIdx;
      this.changeImageBackground(this.coverUrl);
      this.showVideo = false;
      this.fullScreenOpen();
    },
    selectVideos() {
      this.selectedMediaType = "videos";
      this.selectedMediaIdx = 0;
      this.changeImageBackground(this.loadingBackground, "cover");
      this.showVideo = true;
      this.fullScreenOpen();
    },
    fullScreenOpen() {
      this.isFullscreen = true;
      document.getElementById("cover-photo").style.minHeight =
        document.documentElement.clientHeight -
        document.getElementById("main-header").clientHeight +
        "px";
    },
    fullScreenClose() {
      this.isZoomed = false;
      let coverPhotoHolder = document.getElementById("cover-photo");
      coverPhotoHolder.style.minHeight = "65vh";
      coverPhotoHolder.style.backgroundSize = "cover";
      this.isFullscreen = false;
    },
    setCoverFullScreen(imgUrl) {
      let coverPhotoHolder = document.getElementById("cover-photo");
      coverPhotoHolder.style.background =
        "url(" + imgUrl + ") no-repeat center center";
      coverPhotoHolder.style.minHeight =
        document.documentElement.clientHeight -
        document.getElementById("main-header").clientHeight +
        "px";
      coverPhotoHolder.style.backgroundSize = "contain";
    },
    fullscreenPrevious() {
      var elements;
      this.showVideo
        ? (elements = this.dt.marketingDet.videos)
        : (elements = this.dt.marketingDet.images);
      this.selectedMediaIdx--;
      if (this.selectedMediaIdx < 0)
        this.selectedMediaIdx = elements.length - 1;
      this.showVideo
        ? this.changeVideoBackground(elements[this.selectedMediaIdx])
        : this.changeImageBackground(elements[this.selectedMediaIdx].url);
    },
    fullscreenNext() {
      var elements;
      this.showVideo
        ? (elements = this.dt.marketingDet.videos)
        : (elements = this.dt.marketingDet.images);
      this.selectedMediaIdx++;
      if (this.selectedMediaIdx > elements.length - 1)
        this.selectedMediaIdx = 0;
      this.showVideo
        ? this.changeVideoBackground(elements[this.selectedMediaIdx])
        : this.changeImageBackground(elements[this.selectedMediaIdx].url);
    },
    changeImageBackground(imageUrl, backgroundSize) {
      var size = "contain";
      backgroundSize ? (size = backgroundSize) : void 0;
      document.getElementById("cover-photo").style.background =
        "url(" + imageUrl + ") no-repeat center center";
      document.getElementById("cover-photo").style.backgroundSize = size;
    },
    changeVideoBackground(url) {
      this.coverUrl_video = url;
    },
    selectImage(imageId) {
      this.selectedMediaIdx = imageId;
      this.changeImageBackground(
        this.dt.marketingDet.images[this.selectedMediaIdx].url
      );
    },
    navigateTo({ name, params }) {
      this.$router.push({
        name: name,
        params: params,
      });
    },
    editPage() {
      this.navigateTo({
        name: "editListing",
        params: { listingId: this.listingId },
      });
    },
    notifyError(title, msg) {
      this.$notify({
        title: title,
        message: msg,
      });
    },
    getBaseRents(txnDet) {
      return {
        rentDaily: txnDet.priceDaily,
        rentMonthly: txnDet.priceMonthly,
      };
    },
    getDiscounts(txnDet) {
      return {
        weeklyDiscount: txnDet.weeklyDiscount,
        mediumPeriodDiscount: txnDet.mediumPeriodDiscount,
        longPeriodDiscount: txnDet.longPeriodDiscount,
      };
    },
    routeToUser(userMID) {
      console.log("userMID:", this.repMID);

      this.routeTo("user", { id: this.repMID });
    },
    routeTo(where, params) {
      this.$router.push({ name: where, params: params });
    },
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    allCaps: function (value) {
      return value.toUpperCase();
    },
    wc: (value) => (value == true ? "Separated" : "Not Separated"),
    attic: (value) => (value == true ? "Yes" : "No"),
    currency: (value) => {
      return this.getCurrencySign(value);
    },
    storage: (value) => {
      let str = "";
      let arr = value.map((x) => {
        if (x == "sepBuilding") return "Separate Building";
        else if (x == "basement") return "Basement";
        else if (x == "storeRoom") return "Store Room";
      });
      arr.forEach(function (element, index) {
        if (index == 0) str = str + element;
        else if (index == arr.length - 1) str = str + " and " + element;
        else str = str + ", " + element;
      });
      return str;
    },
  },
  data() {
    return {
      narrowWidth: false,
      showDatePeriodDialog: false,
      showMiniDatePicker: false,
      showHighlightedReversePrice: false,
      displayPriceTier: "monthly",
      currentUser: {},
      coverUrl: "",
      coverUrl_video: "",
      selected: "first",
      loading: false,
      loadingText: "Loading",
      areaM2: 0,
      dt: listingModel,
      activeName: "second",
      balcony: lists.balconyTypeList,
      storageList: lists.storageTypeList,
      amenities: lists.amenitiesTypeList,
      isFullscreen: false,
      selectedMediaIdx: 0,
      balconyIfExists: null,
      terraceIfExists: null,
      nrOfBalconiesTotalCalculated: null,
      nrOfStoragesTotalCalculated: null,
      allStoragesIfExists: null,
      kitchenIfExists: null,
      openKitchenIfExists: null,
      nrOfKitchensTotalCalculated: null,
      tagwords: [],
      txnTypeDisplayable: "",
      addFeesDisplayable: "",
      listingOwner: "",
      selectedMoveInDate: undefined,
      selectedMoveOutDate: undefined,
      howManyPeople: "1",
      loadingRep: true,
      repUrl: "",
      repName: "",
      repMID: "",
      contactCardFixed: false,
      mapStartLocation: { lat: 59.0, lng: 24.0 },
      mapLoadedSuccess: false,
      selectedDescription: "",
      showEstDescSelector: false,
      showEngDescSelector: false,
      showRusDescSelector: false,
      selectedDescLang: "est",
      descExpanded: false,
      descExpandToggleText: "Read More",
      currentListingAnalyticsPixel: "",
      creatingRequest: false,
      baseRents: "",
      discounts: "",
      disableHighlightedPriceReverse: false,
      defaultStartingFrom: {},
      showGallery: false,
      serverApi: "",
      showVideo: false,
      showDialogLoginRegister: false,
      selectedMediaType: "photos",
      propertyIsUnavailable: false,
    };
  },
};
</script>
<style scoped>
@import "../../assets/styles/listing-preview.css";
@import "../../assets/styles/global.css";

body {
  font-size: 16px;
}

.pixel-holder {
  max-height: 2px;
  position: absolute;
  z-index: 999999;
}

.cover-video-holder {
  width: 100%;
  height: 100%;
}

.cover-video-container {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 9999;
  height: 100%;
}

#bottom-bar-item-price {
  font-size: 1.5em;
}
.main-title {
  font-size: 40px;
  line-height: 50px;
  color: #4a5963;
}
.sub-title {
  font-size: 22px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #757575;
}

.showCover {
  position: absolute;
  width: 60%;
  bottom: 10px;
  z-index: 1;
  color: white;
  text-align: center;
  border-radius: 24px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
}

.toggleFullScreenBlanket {
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0;
}

.active {
  border: none;
}

.hideCover {
  display: none;
}

#contact-rep-card {
  overflow: hidden;
  position: sticky;
  top: 20px;
}

#inputHorizontal {
  width: 100%;
}

.image {
  opacity: 1;
  /* display: block; */
  width: 100%;
  height: 100%;
  z-index: 1;
  object-fit: contain;
  transition: 0.5s ease;
  backface-visibility: hidden;
  cursor: pointer;
}

.middle {
  z-index: 2;
  color: black;
  border: none;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  background-color: transparent;
  opacity: 0;
}

.down {
  z-index: 2;
  color: #fafafa;
  border-radius: 20px;
  text-align: center;
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 10px;
  background-color: #1f8efa;
  opacity: 0;
}

.content {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/listingComponents/Preview.vue